export const yellow = {
  active: 'hsla(39, 100%, 62%, 1)',
  A800: 'hsla(47, 88%, 53%, 1)',
  800: 'hsla(37, 95%, 56%, 1)',
  700: 'hsla(43, 96%, 58%, 1)',
  500: 'hsla(54, 100%, 62%, 1)',
  100: 'hsla(54, 100%, 88%, 1)',
  50: 'hsla(55, 100%, 95%, 1)',
};

export type YellowPalette = typeof yellow;
